module.exports = __webpack_public_path__ + "static/media/shopList.c812b884.gif";